import type { FC } from "react";
import { getFileTypeLabel } from "./FileIcon";

interface FileTypeLabelProps {
	mimeType: string;
	className?: string;
}

export const FileTypeLabel: FC<FileTypeLabelProps> = ({
	mimeType,
	className = "",
}) => {
	const label = getFileTypeLabel(mimeType);

	return <span className={`text-xs ${className}`}>{label}</span>;
}; 
